export enum RubberGloveSizeEnum {
  SIZE_8 = '8',
  SIZE_8_5 = '8.5',
  SIZE_9 = '9',
  SIZE_9_5 = '9.5',
  SIZE_10 = '10',
  SIZE_10_5 = '10.5',
  SIZE_11 = '11',
  SIZE_11_5 = '11.5',
  SIZE_12 = '12',
}
